"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawDeckCroupierAction = void 0;
const logic_types_1 = require("../logic-types");
class DrawDeckCroupierAction {
    get cardIndex() {
        var _a;
        return (_a = this.card) === null || _a === void 0 ? void 0 : _a.index;
    }
    get cardId() {
        var _a;
        return (_a = this.card) === null || _a === void 0 ? void 0 : _a.cardId;
    }
    constructor(board) {
        this.board = board;
    }
    execute() {
        if (!this.board.deck.hasCards) {
            throw new Error("No cards in the deck");
        }
        this.card = this.board.lastDeckCard();
        if (this.card === undefined) {
            throw new Error("Invalid final deck card");
        }
        const originPile = this.board.getPileByPileId(logic_types_1.PileId.Deck);
        const targetPile = this.board.getPileByPileId(logic_types_1.PileId.Croupier);
        originPile.removeCard(this.card);
        targetPile.addCard(this.card);
        this.card.setStatusWhenNone(logic_types_1.CardDisclosureStatus.Pending);
        return true;
    }
    resolve() {
        var _a;
        (_a = this.card) === null || _a === void 0 ? void 0 : _a.openCard();
    }
    static isAction(action) {
        return action instanceof DrawDeckCroupierAction;
    }
}
exports.DrawDeckCroupierAction = DrawDeckCroupierAction;
